<script lang="ts">
	import type { Component } from 'svelte';

	let { title, desc: description, Icon }: { title: string; desc: string; Icon: Component } = $props();
</script>

<div class="group card rounded-3xl bg-base-200/80 p-8 shadow-md transition-colors duration-300 card-border hover:bg-base-200">
	<div class="mx-auto mb-4 w-fit transition-transform duration-300 group-hover:scale-125">
		<Icon class="h-12 w-12" />
	</div>
	<h3 class="mb-2 text-xl transition-colors group-hover:text-primary">{title}</h3>
	<p class="text-base-content/70">{description}</p>
</div>
